import type { AccordionPassThroughOptions } from "primevue/accordion";

export const accordion: AccordionPassThroughOptions = {
  root: "flex flex-col gap-3"
};
